<template>
  <div class="tags">

    <div :class="{'tag': true, 'display': display}" v-for="(tag, index) in tags" :key="tag.id">
      <div class="text" :id="tag.id" :contenteditable="!display" spellcheck="false" @keydown="onKeydown($event)" @input="onInput($event, index)">{{ tag.text }}</div>
      <div class="icon-box" @click="deleteTag(index)" v-if="!display">
        <font-awesome-icon :icon="['fas', 'times']" class="icon"/>
      </div>
    </div>

    <div class="add-tag" @click="addEmptyTag" v-if="this.tags.length < 10 && !display" title="Add Tag">
      <font-awesome-icon :icon="['fas', 'plus']" class="icon"/>
      <span v-if="tags.length == 0" class="label">Add Tag</span>
    </div>

  </div>
</template>

<script>
import uniqid from 'uniqid'
import axios from 'axios'
import alert from '@/lib/alert'

export default {
  name: 'Tags',
  props: {
    exerciseId: String,
    loadedTags: {},
    display: Boolean
  },
  data() {
    return {
      tags: [],
      savedTags: [],
      inputTimeOut: null
    }
  },
  methods: {
    onKeydown(event) {
      let textLength = event.target.innerText.length;
      if(event.code.slice(0,3) != 'Key' && event.code.slice(0,5) != 'Digit' && event.code != 'Enter' && event.code != 'Space' && event.code != 'Backspace' && event.code != 'ArrowLeft' && event.code != 'ArrowRight') {
        event.preventDefault();
      } else if(event.code == 'Enter' || event.code == 'Space') {
        event.preventDefault();
        this.addEmptyTag();
      } else if(textLength == 14 && event.code != 'Backspace') {
        event.preventDefault();
      }
    },
    onInput(e, index) {
      clearTimeout(this.inputTimeOut);
      let text = e.target.innerText
      this.inputTimeOut = setTimeout(() => {
        this.saveTag(text, index);
      }, 300);
    },
    addEmptyTag() {
      if(this.tags.length < 10) {
        let id = uniqid();
        this.tags.push({ id, text: '' });
        this.savedTags.push({ id, text: '' });
        setTimeout(() => {
          document.getElementById(id).focus();
        }, 1);
      }
    },
    deleteTag(index) {
      this.tags.splice(index, 1);
      this.savedTags.splice(index, 1);
      this.uploadTags();
    },
    saveTag(text, index) {
      clearTimeout(this.inputTimeOut);
      this.savedTags[index].text = text;
      this.uploadTags();
    },
    uploadTags() {
      let validTags = this.savedTags.filter(tag => {
        return tag.text.trim() != '';
      })
      axios({
        method: 'post',
        url: `${process.env.VUE_APP_SERVER_URL}editTags`,
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token') 
        },
        data: {
          exerciseId: this.exerciseId,
          tags: validTags
        }
      }).then(() => {
        console.log('Tags Saved');
      }).catch(() => {
        console.log('Tags Saving Error');
        alert.showError('Tags Saving Error');
      })
    }
  },
  mounted() {
    this.tags = [...this.loadedTags];
    this.savedTags = [...this.loadedTags];
  }
}
</script>

<style lang="scss" scoped>
.tags {
  width: auto;
  height: 100%;
  display: flex;
  align-items: center;
  padding-bottom: 0.1rem;
  flex-wrap: wrap;
  padding-left: 0.2rem;
}

.add-tag {
  height: 1.4rem;
  background-color: #ebc659;
  border-radius: 0.2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-left: 0.4rem;
  padding-right: 0.4rem;

  &:hover {
    cursor: pointer;
  }

  .icon {
    font-size: 0.7rem;
  }

  .label {
    margin-left: 0.4rem;
    font-size: 0.91rem;
    padding-bottom: 0.05rem;
  }
}

.tag {
  height: 1.4rem;
  display: flex;
  padding-left: 0.3rem;
  padding-right: 0.2rem;
  margin-right: 0.5rem;
  background-color: #ebc659;
  border-radius: 0.2rem;
  margin-top: 0.3rem;
  margin-bottom: 0.3rem;

  @media (max-width: 400px) {
    height: 1.2rem;
    padding-left: 0.2rem;
    padding-rigth: 0rem;
  }

  .text {
    width: 100%;
    height: 100%;
    display: flex;
    padding-left: 0.2rem;
    padding-right: 0.1rem;
    outline: none;
    @media (max-width: 400px) {
      font-size: 0.9rem;
    }
  }
  .icon-box {
    width: 1.4rem;
    height: 1.4rem;
    display: flex;
    justify-content: center;
    align-items: center;

    &:hover {
      cursor: pointer;
    }
    
    .icon {
      font-size: 0.7rem;
    }
  }
}

.display {
  padding-left: 0.3rem;
  padding-right: 0.3rem;
}
</style>